export default "__VITE_ASSET__34fe8873__"